import Link from "next/link";
import style from "./styles/help-fixed-button.module.scss";
import React from "react";
import { useMobile } from "@/hooks/use-responsive";

interface HelpFixedButtonProps {
  href: string;
}

const HelpFixedButton = ({ href }: HelpFixedButtonProps) => {
  const { isMobile } = useMobile();
  return (
    !isMobile && (
      <Link href={href} className={style.help_button}>
        Help
      </Link>
    )
  );
};

export default HelpFixedButton;
